import { useEffect } from 'react';
import { http } from '@/shared/api/http';
import { useAuth, type AuthUser } from './auth-store';
import { refresh, type MeResponse } from './api';

export function useBootstrapAuth(): void {
  useEffect(() => {
    refresh()
      .then(() => http<MeResponse>('/me'))
      .then((user) => {
        useAuth.getState().set({ status: 'authed', user: user as AuthUser });
      })
      .catch(() => {
        useAuth.getState().set({ status: 'anon', accessToken: null, user: null });
      });
  }, []);
}
